import HekaLoader from "@/assets/heka-loader.svg?react";
import { useAccountProxy } from "@/stores/account.store";
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

export function VerifyPage() {
  const [params] = useSearchParams();
  const code = params.get("code");
  const userID = params.get("userID");
  const accountProxy = useAccountProxy();
  const navigate = useNavigate();
  useEffect(() => {
    if (!userID || !code) {
      navigate("/login");
    } else {
      accountProxy.verifyEmail(userID, code).finally(() => navigate("/login"));
    }
  });
  return (
    <div className="flex flex-col items-center justify-center h-full gap-12">
      <HekaLoader className="max-w-sm max-h-32" />
    </div>
  );
}
